import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyUser = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(()=>{
        getData()
    },[])
    useEffect(()=>{
    if(value && content.length > 0 && (props.userNumber || props.userEmail)){
        let details = content.find((user)=> user.u_id === value)
        if(details){
            props.userNumber && setFieldValue(props.userNumber, details.mobile_number)
            props.userEmail && setFieldValue(props.userEmail, details.email_address)
        }
    }
    },[value, content])
    
    const getData = async()=>{
        let roleParam = {}
        if(props.roleValidation && props.roleName){
            let roleId = await getRoleId(props.roleName)
            if(roleId){
                roleParam = {roleId}
            }else{
                return ;
            }
        }
        setloading(true)
        ReadAxios({ url: "userMaster", readItems: {...roleParam} })
        .then((result) => {
            if(result?.data?.resultSet.length > 0){
                setcontent(result?.data?.resultSet)
            }
            setloading(false)
        })
    }
    const getRoleId = async(roleName)=>{
        try{
            let result =  await ReadAxios({ url: "roles", readItems: { module_name: "TA" } })
            let roleId =  result.data.resultSet.length > 0 &&
            result.data.resultSet.find((role)=> role.role.toString().toUpperCase() === roleName.toString().toUpperCase())?.roleId ;
            return roleId ;
        }catch(err){
            console.log(err);
        }
        
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.u_id
            temp.text = object.realname
            temp.value = object.u_id
            temp.raw = object
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyUser